import { Model } from '@vuex-orm/core';
import RegistrationServiceApi from '../api/registration/registrationService';

export default class Register extends Model {
	static entity = 'registration';

	static fields() {
		return {
			uci: this.attr(null),
			firstName: this.attr(null),
			lastName: this.attr(null),
			email: this.attr(null),
			birthDate: this.attr(null),
			addressLines: this.attr(null),
			lastLoginTime: this.attr(null),
			lastPasswordChangeTime: this.attr(null),
			passwordExpired: this.attr(null)
		};
	}

	static async registerUser(email) {
		const registeredProfile = await RegistrationServiceApi.userRegistered(email);
		await super.insert({
			data: registeredProfile
		});
		return registeredProfile;
	}

	static async deleteUser(email, token) {
		const registeredProfile = await RegistrationServiceApi.userDeleted(email, token);
		await super.insert({
			data: registeredProfile
		});
		return registeredProfile;
	}

	static async pingRegistrationApi(email) {
		const pingResponse = await RegistrationServiceApi.pingRegistrationApi(email);
		return pingResponse;
	}
}
